"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductItemAttributesSchema = void 0;
const zod_1 = require("zod");
exports.ProductItemAttributesSchema = zod_1.z.object({
    id: zod_1.z.number(),
    productId: zod_1.z.number().nullable().optional().default(0),
    description: zod_1.z.string().nullable().optional(),
    imageOrdering: zod_1.z
        .array(zod_1.z.number().int().positive())
        .nullable()
        .optional()
        .default([])
        .transform((val) => Array.from(new Set(val))),
    retailPrice: zod_1.z.number(),
    lengthCm: zod_1.z.number(),
    heightCm: zod_1.z.number(),
    widthCm: zod_1.z.number(),
    weightKg: zod_1.z.number(),
    isActive: zod_1.z.boolean(),
});
//# sourceMappingURL=product_item.js.map